import { render, staticRenderFns } from "./createArticle_two.vue?vue&type=template&id=3ad4037e&scoped=true&"
import script from "./createArticle_two.vue?vue&type=script&lang=js&"
export * from "./createArticle_two.vue?vue&type=script&lang=js&"
import style0 from "./createArticle_two.vue?vue&type=style&index=0&id=3ad4037e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad4037e",
  null
  
)

export default component.exports